import { ProductVariantGroupDto } from 'src/types/generated';

import BaseReadApiModule from 'src/api/baseRead';

class ProductVariantGroupApi extends BaseReadApiModule<ProductVariantGroupDto> {
  protected baseRoute = '/product-variant-groups';
}

export default ProductVariantGroupApi;
